import { render } from "./PlanTratamientosList.vue?vue&type=template&id=36cd24ea&scoped=true"
import script from "./PlanTratamientosList.vue?vue&type=script&lang=js"
export * from "./PlanTratamientosList.vue?vue&type=script&lang=js"

import "./PlanTratamientosList.vue?vue&type=style&index=0&id=36cd24ea&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cd24ea"]])

export default __exports__